// material-ui
import { DataGrid } from '../../../components/grid/DataGrid';

// project import
import MainLayout from '../../../layout/MainLayout';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState } from 'react';
import MainCard from '../../../components/MainCard';
import {
  DeleteOutlined,
  EditOutlined,
  UserOutlined,
  FileTextOutlined,
  TeamOutlined,
  CommentOutlined
} from '@ant-design/icons';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid-pro';

import { Button, Box } from '@mui/material';

import {
  actions as routeActions,
  types as routes
} from 'reducers/rotas.actions';

import * as actions from 'reducers/parceiros.reducer';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import useTheme from '@mui/system/useTheme';
import { toast } from 'react-toastify';
import { funcaoFiltro } from 'utils/funcaoFiltro';
import { opcoesFiltro } from 'utils/opcoesFiltro';

const OportunidadesPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const parceiros = useSelector((state) => state.parceiros.parceiros.data);
  const loading = useSelector((state) => state.parceiros.parceiros.loading);
  const perfil = useSelector((state) => state.usuario.perfil);

  const parceirosData = parceiros.map((item) => ({
    ...item,
    nomeRegional: item.regional.nomeRegional
  }));

  const rows = parceirosData;

  const regionais = [];

  for (let parceiro of rows) {
    const item = {
      nome: parceiro.nomeRegional,
      codigo: parceiro.nomeRegional
    };

    if (!regionais.find((regional) => regional.codigo === item.codigo)) {
      regionais.push(item);
    }
  }

  const columns = [
    {
      field: 'nomeParceiro',
      headerName: 'Nome',
      flex: 1
    },
    {
      field: 'nomeRegional',
      headerName: 'Regional',
      flex: 1,
      filterOperators: [
        {
          label: 'igual à',
          value: 'is',
          getApplyFilterFn: (filterItem) => funcaoFiltro(filterItem),
          InputComponent: (props) => opcoesFiltro(props, [...regionais])
        }
      ]
    },
    {
      field: 'tipoOrigem',
      headerName: 'Origem',
      flex: 1,
      valueFormatter: (value) => {
        return [
          { codigo: 'RM', nome: 'RE/MAX' },
          { codigo: 'IN', nome: 'Indicação' },
          { codigo: 'PR', nome: 'Prospecção' },
          { codigo: 'ST', nome: 'Site' },
          { codigo: 'MK', nome: 'Marketing' }
        ].find((item) => item.codigo === value)?.nome;
      },

      filterOperators: [
        {
          label: 'igual à',
          value: 'is',
          getApplyFilterFn: (filterItem) => funcaoFiltro(filterItem),
          InputComponent: (props) =>
            opcoesFiltro(props, [
              { codigo: 'RM', nome: 'RE/MAX' },
              { codigo: 'IN', nome: 'Indicação' },
              { codigo: 'PR', nome: 'Prospecção' },
              { codigo: 'ST ', nome: 'Site' },
              { codigo: 'MK', nome: 'Marketing' }
            ])
        }
      ]
    },
    {
      field: 'tipoSituacao',
      headerName: 'Situação',
      flex: 1,
      valueFormatter: (value) => {
        return value === 'A' ? 'Ativo' : value === 'I' ? 'Inativo' : '';
      },
      filterOperators: [
        {
          label: 'igual à',
          value: 'is',
          getApplyFilterFn: (filterItem) => funcaoFiltro(filterItem),
          InputComponent: (props) =>
            opcoesFiltro(props, [
              { codigo: 'A', nome: 'Ativo' },
              { codigo: 'I', nome: 'Inativo' }
            ])
        }
      ]
    }
  ];

  const [open, setOpen] = useState(false);

  const handleClickOpen = (row) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNewParceiro = () => {
    if (perfil === 'PC') {
      return toast.error('Você não tem permissão para criar parceiros.');
    }
    dispatch(
      routeActions.redirectTo(routes.PARCEIRO, {
        idParceiro: 'novo'
      })
    );
  };

  const CustomToolbar = ({ apiRef }) => {
    const selectedRows = apiRef.current.getSelectedRows();
    const selectedRowData = Array.from(selectedRows.values());

    const handleDeleteClick = () => {
      if (perfil === 'PC') {
        return toast.error('Você não tem permissão para excluir parceiros.');
      }
      dispatch(actions.excluirParceiroRequest({ value: selectedRowData[0] }));
      setOpen(false);
    };

    const handleEdit = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        dispatch(
          routeActions.openNewWindowWith(routes.PARCEIRO, {
            idParceiro: selectedRowData[0].idParceiro
          })
        );
      }
    };

    const handleDocumentos = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        dispatch(
          routeActions.openNewWindowWith(routes.PARCEIRO_DOCUMENTO, {
            idParceiro: selectedRowData[0].idParceiro
          })
        );
      }
    };

    const handleFup = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        dispatch(
          routeActions.openNewWindowWith(routes.PARCEIRO_FUP, {
            idParceiro: selectedRowData[0].idParceiro
          })
        );
      }
    };

    const handleClickParceiros = () => {
      dispatch(
        routeActions.openNewWindowWith(routes.USUARIOS_PARCEIROS, {
          idParceiro: selectedRowData[0].idParceiro
        })
      );
    };

    return (
      <>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Confirmação para Exclusão de Vendedor</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tem certeza de que deseja excluir o Parceiro{' '}
              {selectedRowData[0]?.nomeParceiro}? Ao excluir um Parceiro, não
              será mais possível recuperar suas informações.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleDeleteClick} color="error">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport
            csvOptions={{ includeHeaders: true, allColumns: true }}
          />
          <Button
            variant="text"
            color="primary"
            onClick={handleNewParceiro}
            startIcon={<TeamOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Incluir Parceiro
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={handleEdit}
            disabled={selectedRows.size !== 1}
            startIcon={<EditOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Editar
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={
              selectedRows.size !== 1 ||
              selectedRowData[0]?.tipoSituacao !== 'A'
            }
            onClick={handleClickOpen}
            startIcon={<DeleteOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px',
              color: `${
                selectedRows.size !== 1 ||
                selectedRowData[0]?.tipoSituacao !== 'A'
                  ? theme.palette.grey.lighter
                  : theme.palette.error.main
              } !important`
            }}
          >
            Excluir
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={handleDocumentos}
            startIcon={<FileTextOutlined />}
            disabled={selectedRows.size !== 1}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Documentos
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={handleFup}
            startIcon={<CommentOutlined />}
            disabled={selectedRows.size !== 1}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Comentários
          </Button>

          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleClickParceiros}
            startIcon={<UserOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Usuários Parceiros
          </Button>
        </GridToolbarContainer>
      </>
    );
  };

  return (
    <MainLayout>
      <MainCard
        title="Configuração de Parceiros"
        border={false}
        sx={{ paddingBottom: '0px' }}
      >
        <Box sx={{ marginTop: '5px' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[10]}
            getRowId={(row) => row.idParceiro}
            toolbar={CustomToolbar}
            loading={loading}
            pageSize={10}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              },
              density: 'standard'
            }}
            noLineText="Nenhum parceiro encontrado"
          />
        </Box>
      </MainCard>
    </MainLayout>
  );
};

export default OportunidadesPage;
